import { FC } from 'react';
import { addContractIcon } from '../../assets';
import { Layout } from '../../shared/ui/Layout';
import styles from './ContractAddDepositPage.module.scss';
import AddDeposit from '../../entities/deposit/ui/AddDeposit/AddDeposit';
import {useTranslation} from "react-i18next";

const ContractAddDepositPage: FC = () => {
    const {t} = useTranslation()

    return (
        <Layout
            title={t('new_deposit')}
            icon={addContractIcon}
            bgColor1="rgba(61, 25, 164, 1)"
            bgColor2="rgba(88, 29, 186, 1)"
            bgColor3="rgba(183, 112, 255, 1)"
            bgColor4="rgba(175, 137, 255, 1)"
            bgColor5="rgba(193, 177, 255, 1)">
            <div className={styles.ContractAddDepositPage}>
                <AddDeposit />
            </div>
        </Layout>
    );
};

export default ContractAddDepositPage;
